import React from 'react';
import { Tag } from '../../services/goalService';
import './TagChip.css';

interface TagChipProps {
  tag: Tag;
  className?: string;
  children?: React.ReactNode;
}

/** Neutral pill with a colored dot: the tag color never has to meet text contrast. */
const TagChip: React.FC<TagChipProps> = ({ tag, className = '', children }) => (
  <span className={`tag-chip ${className}`.trim()}>
    <span className="tag-chip__dot" style={{ backgroundColor: tag.color }} aria-hidden="true" />
    <span className="tag-chip__name">{tag.name}</span>
    {children}
  </span>
);

export default TagChip;
